var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "remix-icons/line/system/shield-flash-line",
    opacity: 0.7,
    clipPath: "url(#clip0_3292_22808)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.522 1.88433L8 0.666992L13.478 1.88433C13.626 1.91723 13.7584 1.99964 13.8533 2.11793C13.9482 2.23622 14 2.38334 14 2.53499V9.19299C14 9.85148 13.8373 10.4998 13.5266 11.0803C13.2158 11.6609 12.7666 12.1557 12.2187 12.521L8 15.3337L3.78133 12.521C3.23352 12.1558 2.78431 11.6611 2.47357 11.0806C2.16282 10.5002 2.00016 9.85204 2 9.19366V2.53499C2.00003 2.38334 2.05176 2.23622 2.14666 2.11793C2.24156 1.99964 2.37396 1.91723 2.522 1.88433ZM3.33333 3.06966V9.19299C3.33334 9.63196 3.44172 10.0641 3.64884 10.4512C3.85597 10.8382 4.15543 11.1681 4.52067 11.4117L8 13.7317L11.4793 11.4117C11.8445 11.1682 12.1439 10.8384 12.351 10.4515C12.5581 10.0646 12.6665 9.63252 12.6667 9.19366V3.06966L8 2.03366L3.33333 3.06966ZM8.66667 6.66699H10.6667L7.33333 11.3337V8.00033H5.33333L8.66667 3.33366V6.66699Z",
    fill: "#09121F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3292_22808"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.efc4c634b483040f4f91878d9b39b8fe.svg";
export { ForwardRef as ReactComponent };